import appLocaleData from "react-intl/locale-data/af";
import afMessages from "../locales/af-AF";

const AfLang = {
  messages: {
    ...afMessages,
  },
  locale: "af-AF",
  data: appLocaleData,
};
export default AfLang;
